<template>
  <span
    :class="[borderClass, textClass]"
    class="text-xs uppercase border-2 rounded px-1 py-0.5 shadow-podHover bg-surface-primary font-label"
  >
    <slot></slot>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BadgeDefault',
  props: {
    textClass: {
      type: String,
      default: 'text-seats-arrived',
    },
    borderClass: {
      type: String,
      default: 'border-seats-arrived',
    },
  },
})
</script>
